import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment-timezone';
import Icon from 'icon-component';

const EventItem = ({
    siteUrl,
    venueUrl,
    event,
    selected,
    onClick
}) => {
    const {
        title,
        starts,
        ends,
        seo_url,
        destination: {
            relative_url,
            title: destinationTitle,
            street_address,
            city,
            state,
            latitude,
            longitude
        }
    } = event;
    const classes = classNames(
        'SH-EventItem',
        {'SH-EventItem-selected': selected}
    );
    const startsMoment = moment.tz(starts, window.currentCityTimezone);

    return (
        <div
            className={classes}
            itemScope
            itemType="http://schema.org/Event"
            onClick={() => {
                onClick(event);
            }}
        >
            <div className="SH-EventItem-content">
                <h1 className="heading-md" itemProp="name">{title}</h1>
                <meta itemProp="url" content={`${siteUrl}/${venueUrl}/${seo_url}`} />
                <span itemProp="startDate" content={starts} className="SH-EventItem-date">{startsMoment.format('ddd, MMM D, YYYY')}</span>
                <span itemProp="endDate" content={ends} className="SH-EventItem-time">{startsMoment.format('h:mm a')}</span>
                <span itemProp="offers" itemScope itemType="http://schema.org/AggregateOffer">
                    <meta itemProp="url" content={`${siteUrl}/${venueUrl}/${seo_url}`} />
                </span>
                <span itemProp="location" itemScope itemType="http://schema.org/Place">
                    <meta itemProp="url" content={`${siteUrl}/${relative_url}`} />
                    <meta itemProp="name" content={destinationTitle} />
                    <span itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                        {street_address &&
                            <meta itemProp="streetAddress" content={street_address} />
                        }
                        {city &&
                            <meta itemProp="addressLocality" content={city} />
                        }
                        {state &&
                            <meta itemProp="addressRegion" content={state} />
                        }
                    </span>
                    <span itemProp="geo" itemScope itemType="http://schema.org/GeoCoordinates">
                       <meta itemProp="latitude" content={latitude} />
                       <meta itemProp="longitude" content={longitude} />
                    </span>
                </span>
            </div>
            <Icon name="chevron-right" />
        </div>
    );
};

EventItem.propTypes = {
    siteUrl: PropTypes.string.isRequired,
    venueUrl: PropTypes.string,
    event: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

export default EventItem;



// WEBPACK FOOTER //
// ./widget/src/js/components/event/EventItem.jsx